<template lang="pug" src="./hero-home.pug"></template>

<script>
import { scrollNav } from 'components/mixins'
import VueTrigger from 'components/block/block-vue-trigger/block-vue-trigger'

export default {
  props: ['props'],
  mixins: [scrollNav],
  mounted () {
    const video = this.$refs.hero
    video.play()
  },
  components: {
    VueTrigger
  }
}
</script>



// WEBPACK FOOTER //
// hero-home.vue?77207d55